import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { calculateTotalPaid, convertCurrency, numberFormat } from '../../helper';
import { useLazyQuery } from '@apollo/client';
import { GET_BANKS } from '../../apollo/bank/query';
import { USER_KEY } from '../../const';
import { GrCheckboxSelected } from 'react-icons/gr';
import { GrCheckbox } from 'react-icons/gr';
import { GiCancel } from 'react-icons/gi';
import { GET_EXCHANGRATE } from '../../apollo/exchangeRate/Query';
import { GET_SHOP } from '../../apollo/shop/Query';

export default function BillOfferPrice80({ offerPriceGroupData, Location }) {
  const [bankaccount, setBankAccount] = useState();
  const shop = JSON.parse(localStorage.getItem('SHOP_DATA'));
  const [bankImage, setBankImage] = useState();
  const [banknumber, setBankNumber] = useState();
  const [exchangeRate, setExchangeRate] = useState([]);
  const [isBillNumber, setIsBillNumber] = useState(false); 


  const [getBank, { data: getbankData, loading: bankloadding }] = useLazyQuery(GET_BANKS, { fetchPolicy: "network-only" });
  const [LoadExchangeRate, { data: GetExchangeRate, loading }] = useLazyQuery(GET_EXCHANGRATE, { fetchPolicy: "network-only" });
  const [loadShop, { data: shopData, loading: loadingShop }] = useLazyQuery(
    GET_SHOP,
    {
      fetchPolicy: "network-only",
    }
  );
 
  useEffect(() => {
    if (getbankData) {
      setBankAccount(getbankData?.banks?.data);
    }
  }, [getbankData]);

  useEffect(() => {
    if (bankaccount) {
      setBankImage(bankaccount[0]?.image);
      setBankNumber(bankaccount[0]?.bankAccount);
    }
  }, [bankaccount]);

  useEffect(() => {
    if (shopData) {
      setIsBillNumber(shopData?.shop?.isBillNumber); // Update isBillNumber from shopData
    }
  }, [shopData]);

  const _fetchBank = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    await getBank({
      variables: {
        limit: 100,
        orderBy: "createdAt_DESC",
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });
  };

  useEffect(() => {
    _fetchExchangeRate();
    _fetchShop()
    _fetchBank();

  }, []);

  useEffect(() => {
    if (GetExchangeRate) {
      setExchangeRate([{
        id: GetExchangeRate?.exchangeRate?.id,
        currency: 'ບາດ',
        exchangeRate: GetExchangeRate?.exchangeRate?.baht
      }, {
        id: GetExchangeRate?.exchangeRate?.id,
        currency: 'ໂດລາ',
        exchangeRate: GetExchangeRate?.exchangeRate?.usd
      }]);
    }
  }, [GetExchangeRate]);

  const _fetchShop = async () => {
    let shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    loadShop({
      variables: {
        where: {
          id: shopId,
        },
      },
    });
  };

  const _fetchExchangeRate = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    await LoadExchangeRate({
      variables: {
        exchangeRateWhere2: {
          shop: shopId,
        },
      },
    });
  };

  const convertKipToBaht = (amount) => {
    const bahtRate = exchangeRate.find(rate => rate.currency === 'ບາດ')?.exchangeRate || 0;
    return amount / bahtRate;
  };

  const convertKipToUsd = (amount) => {
    const usdRate = exchangeRate.find(rate => rate.currency === 'ໂດລາ')?.exchangeRate || 0;
    return amount / usdRate;
  };


  const totals = calculateTotalPaid(Location?.state?.state?.sumPrice, Location?.state?.state?.currency, exchangeRate);


  return (
    <div>
      <div style={{ textAlign: 'center' }}>
        <b style={{ fontSize: '20px' }}>ຮ້ານ {shop?.name}</b>
      </div>
      <div style={{ textAlign: 'center' }}>
        {shop?.address?.village + ', ' + shop?.address?.district + ', ' + shop?.address?.province}
      </div>
      <div style={{ textAlign: 'center' }}>{shop?.phone}</div>
      <div style={{ textAlign: 'center' }}>
        <b style={{ fontSize: '25px' }}>ບິນເກັບເງິນ</b>
      </div>
      <div style={{ textAlign: 'left' }}>ເລກທີບິນ : {Location?.state?.state.code}</div>
      <div style={{ textAlign: 'left' }}>ພະນັກງານຂາຍ : {Location?.state?.state?.staff} {Location?.state?.state?.staffLastname}</div>
      <div style={{ textAlign: 'left' }}>ຊື່ລູກຄ້າ: {Location?.state?.state?.customerName} {Location?.state?.state?.customerLastName}</div>
      <div style={{ textAlign: 'left' }}>ທີ່ຢູ່: {Location?.state?.state?.village} {Location?.state?.state?.district} {Location?.state?.state?.province}</div>
      <div style={{ textAlign: 'left' }}>ເບີໂທ: {Location?.state?.state?.phone}</div>
      <div style={{ textAlign: 'left', borderBottom: '1px solid black' }}>ວັນທີ : {moment(Location?.state?.state?.createdAt).format('DD/MM/YYYY HH:mm:ss')}</div>
      <div style={{ textAlign: 'left' }}>
        <div>ລາຍການສິນຄ້າ</div>
      </div>
      <Order>
        <>
          {offerPriceGroupData?.offerprices?.map((order, index) => (
            <div
              style={{
                fontSize: 1,
              }}
              key={index}
            >
              <div style={{ textAlign: 'left', fontSize: 14, display: 'flex' }}>
                <div style={{ fontWeight: 'bold', width: '10px', display: 'flex', justifyContent: 'flex-end', marginRight: '5px', marginLeft: '10px' }}>
                  {index + 1})
                </div>
                <div>{order?.productName}</div>
              </div>
              <div style={{ textAlign: 'left', fontSize: 14, paddingLeft: '15px', display: 'flex', justifyContent: 'space-between' }}>
                <div>{order?.amount} {order?.unit} X {order?.price ? numberFormat(order?.price) : '-'} {' ' + convertCurrency(order?.currency)}</div>
                <div style={{ fontWeight: 'bold' }}>{numberFormat(order?.price * order?.amount)}{' ' + convertCurrency(order?.currency)}</div>
              </div>
            </div>
          ))}

          <hr style={{ border: '1px solid #000' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>ຍອດລວມ :</div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <span>{numberFormat(Location?.state?.state?.totalPrice ?? 0)} ₭</span>
              <span>{numberFormat(Location?.state?.state?.sumPriceBaht ?? 0)} ฿</span>
              <span>{numberFormat(Location?.state?.state?.sumPriceUsd ?? 0)} $</span>
            </div>
          </div>


          {!isBillNumber ? (
            <>
            <hr style={{ border: '1px solid #000' }} />
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  <b>ເງິນລວມທັງໝົດ</b>
                </span>
                <span>
                  <b>
                    {numberFormat(Location?.state?.state?.sumPrice ?? 0)} ກີບ
                  </b>
                </span>
              </div>
            </>
          ) : (
            <>

              <div style={{ display: "flex", marginTop: 5, paddingTop: 5, justifyContent: "space-between", borderTop: '1px solid gray' }}>
                <p style={{ fontSize: 14, fontWeight: "bold" }}>ເງິນທີ່ຕ້ອງຈ່າຍທັງໝົດ</p>
                <p style={{ fontSize: 14, fontWeight: "bold" }}>
                  {numberFormat(Location?.state?.state?.sumPrice ?? 0)} ກີບ
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontSize: 11, fontWeight: "300" }}>ຈ່າຍເປັນເງິນບາດ</p>
                <p style={{ fontSize: 11, fontWeight: "300" }}> {numberFormat(totals?.totalBaht ?? 0)}{" "} ບາດ</p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontSize: 11, fontWeight: "300" }}>ຈ່າຍເປັນເງິນໂດລາ</p>
                <p style={{ fontSize: 11, fontWeight: "300" }}> {numberFormat(totals?.totalUsd ?? 0)} ໂດລາ</p>
              </div>

            </>
          )}


          <div style={{ fontWeight: 'bold', fontSize: 18 }}>
            ເລກບັນຊີ : {banknumber}
          </div>
          <div>
            {Location?.state?.state.status === 'NOTYETPAID' ? (
              <>
                <div><GrCheckbox /> ຈ່າຍເງິນເເລ້ວ</div>
                <div><GrCheckboxSelected /> ຍັງບໍ່ທັນຈ່າຍເງິນ</div>
              </>
            ) : Location?.state?.state.status === 'COMPLETED' ? (
              <>
                <div><GrCheckboxSelected /> ຈ່າຍເງິນເເລ້ວ</div>
                <div><GrCheckbox /> ຍັງບໍ່ທັນຈ່າຍເງິນ</div>
              </>
            ) : Location?.state?.state.status === 'CANCELLED' ? (
              <div><GiCancel /> ສົ່ງຄືນສິນຄ້າ</div>
            ) : (
              ""
            )}
          </div>
          <hr style={{ border: '1px solid #FFFFFF' }} />
        </>
      </Order>
    </div>
  );
}

const Name = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr;
`;

const Price = styled.div`
  display: flex;
`;

const Container = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
`;

const Img = styled.div`
  width: 90px;
  height: 90px;
  font-size: 14px;
`;

const Order = styled.div`
  display: flex;
  flex-direction: column;
`;
